import { FC } from 'react';

import { ILayer } from '../../../../slice/types';
import { Col, Row } from 'antd';
import { Draggable } from 'react-beautiful-dnd';

import * as S from './DraggableLayerItem.styles';
import { MapMenuRow } from 'app/components/MapMenu/MapMenu';

interface IProps {
  index: number;
  layer: ILayer;
  isSliderVisible: boolean;
  onCheckboxClick: () => void;
  onOpacityChange: (opacityValue: number) => void;
  onEyeClick: () => void;
}

const DraggableLayerItem: FC<IProps> = ({
  index,
  layer,
  isSliderVisible,
  onCheckboxClick,
  onOpacityChange,
  onEyeClick,
}) => {
  return (
    <Draggable draggableId={layer.id} index={index}>
      {provided => (
        <MapMenuRow
          key={layer.id}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <S.DragICon {...provided.dragHandleProps} />
          <Col style={{ flex: 1 }}>
            <Row>
              <S.Checkbox
                onChange={onCheckboxClick}
                checked={layer.visible}
                key={layer.id}
              >
                {layer.name}
              </S.Checkbox>
              <S.EyeIcon
                $disabled={!layer.visible}
                $active={layer.visible && isSliderVisible}
                onClick={() => {
                  if (layer.visible) {
                    onEyeClick();
                  }
                }}
              />
            </Row>

            {layer.visible && isSliderVisible && (
              <Row>
                <S.OpacitySlider
                  defaultValue={layer.opacity * 100}
                  disabled={!layer.visible}
                  onAfterChange={(value: number) => onOpacityChange(value)}
                />
              </Row>
            )}
          </Col>
        </MapMenuRow>
      )}
    </Draggable>
  );
};

export default DraggableLayerItem;
